<template>
  <section id="podcast" class="vue-podcast-list spacer">
    <div class="title big">Podcast</div>
    <div class="title pt click" :class="{ open: clicked }" @click="openList">
      Episodes 2020
    </div>
    <div v-if="clicked" lass="">
      <podcast-item
        v-for="(pod, index) in podcast.episodes"
        :key="'p-' + index"
        :podcast="pod.embed"
      />
    </div>
  </section>
</template>

<script>
import API from "@/api/service";
import PodcastItem from "@/components/PodcastItem.vue";
export default {
  components: {
    PodcastItem,
  },
  data() {
    return {
      podcast: [],
      clicked: false,
      // loaded: false
    };
  },
  created() {
    API.podcast(this.$i18n.locale).then((page) => {
      this.podcast = page.data.result;
      // this.loaded = true;
    });
  },
  methods: {
    openList() {
      this.clicked = !this.clicked;
      this.$router.push({
        path: "/" + this.$i18n.locale + "/podcast",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.click {
  cursor: pointer;
}
#podcast {
  padding-bottom: 0 !important;
  border-bottom: 0 !important;
}
.vue-podcast-list {
  .click {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      right: 0;
      width: calc(1 * var(--bs));
      height: 0;
      border-top: var(--b) solid #000;
      transform: rotate(90deg);
    }
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      right: 0;
      width: calc(1 * var(--bs));
      height: 0;
      border-top: var(--b) solid #000;
    }
    &.open {
      &:before {
        transform: rotate(45deg);
      }
      &:after {
        transform: rotate(135deg);
      }
    }
  }
  // border-color: black;
  // border-style: solid;
  // border-left-width: 1px;
  // border-top-width: 1px;
  // border-right-width: 1px;
  // margin-bottom: 1rem;
}
</style>
